// extracted by mini-css-extract-plugin
export default {"selectedPaymentOption":"BlERG","removeSelectedPaymentOption":"uT773","amountSpace":"w3hG1"};